/**
 * Renders a drop-down menu to sort the ravens by either name in alphabetical order ("alphaNumero"),
 * or by most recet update ("time").
 * Rendered in GridPage.js
 */

import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';
import SelectDropDown from '../../common/SelectDropDown';

export default class SortingButton extends React.PureComponent {

    render() {
        const { value, onChange, disabled } = this.props;

        const options = [
            { label: strings.by_name, value: 'alphaNumero', checked: value === 'alphaNumero' },
            { label: strings.by_time, value: 'time', checked: value === 'time' },
        ];

        const handleChange = (index) => {
            const selectedOption = options[index];
            onChange(selectedOption.value);
        };

        return (
           <div className="grid-options-period">
               <div className="grid-options-period-label">
                   {strings.sort_by}
               </div>
               <SelectDropDown
                   options={options}
                   onChange={handleChange}
                   singleOnlySelection={true}
                   requiredSelection={true}
                   isDefaultOptional={true} 
               />
           </div>
        );
    }
}

SortingButton.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};